export default __webpack_public_path__ + "static/media/Penny_Tremblay_AHV_In_Moms_We_Trust.1bc82dd7.jpg";